import { http } from '@/api/_base';

const upload_file = (formData: string) => {
	return http.post('share/', formData, {
		withCredentials: true,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

const delete_file = (user: string, hash: string, name: string) => {
	return http.delete('share/', {
		params: {
			user: user,
			hash: hash,
			name: name
		},
		withCredentials: true,
		headers: {
			'Content-Type': 'application/json'
		}
	});
};

const get_file_list = () => {
	return http.get('share/', { withCredentials: true });
};

export { upload_file, delete_file, get_file_list };
